<template>
  <div id="ic-signup">
    <ProgrammeSignup
      :title="title"
      :programmeCode="programmeCode"
      :ctaButton="ctaButton"
      :themeColor="themeColor"
      :sale="sale"
      logo="/assets/images/inner-circle-logo.svg"
    >
      <template v-slot:sidebar>
        <div class="included mt-5 mt-lg-0">
          <h2>The 4-Month Inner Circle Program includes:</h2>
          <div
            v-for="(included, index) in includedContent"
            :key="index"
            class="smaller py-2"
          >
            <i class="fa fa-check c-outline-mustard mr-2"></i>
            <span v-if="included.bonus" class="bonus mr-2">{{
              included.bonus
            }}</span>
            <span>{{ included.description }}</span>
          </div>
        </div>
        <div class="included mt-5">
          <h2>Privacy</h2>
          <p class="smaller mt-3">
            We will not share or trade online information that you provide us
            (including e-mail addresses).
          </p>
          <span>
            <i class="fal fa-user-shield c-mm mr-2"></i>
            <span class="smaller c-dark-gray">Your privacy is protected</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Security</h2>
          <p class="smaller mt-3">
            All personal information you submit is encrypted and secure.
          </p>
          <span>
            <i class="fal fa-lock-alt c-mm mr-2"></i>
            <span class="smaller c-dark-gray">Your information is secure</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Need help?</h2>
          <div class="small mt-3">
            Email:
            <a href="mailto:team@heymarvelous.com" class="c-mm"
              >team@heymarvelous.com</a
            >
          </div>
        </div>
      </template>
    </ProgrammeSignup>
  </div>
</template>

<script>
import ProgrammeSignup from '@/web/views/admin/ProgrammeSignup';
export default {
  name: 'InnerCircle4MonthsProgrammeSignup',
  components: { ProgrammeSignup },
  props: {
    title: {
      type: String,
      default: null,
    },
    programmeCode: {
      type: String,
      default: null,
    },
    ctaButton: {
      type: String,
      default: 'SIGNUP.BUTTON.GET_STARTED',
    },
    themeColor: {
      type: String,
      default: 'ic',
    },
    sale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    includedContent() {
      return [
        {
          description:
            'Bi-weekly Live Strategy Sessions with Jeni (Value $2,000+)',
        },
        {
          description:
            'Bi-weekly Live Mindset Sessions with Sandy (Value $2,000+)',
        },
        {
          description:
            'Weekly Critique Sessions with Inner Circle Team (Value $2,000+)',
        },
        {
          description:
            '4-Month Access to Soulful MBA Business Training Courses (Value $2,333)',
        },
        {
          description:
            '4-Month Subscription to Pro Plan of Marvelous Software (Value $716)',
        },
        {
          description: 'Film School (Value $199)',
        },
        {
          bonus: 'BONUS:',
          description: 'Plug-n-Play Template Library (Value $1,700)',
        },
        {
          bonus: 'BONUS:',
          description: 'Make Room for Magic Course (Value $97)',
        },
        {
          bonus: 'BONUS:',
          description: 'Social Media Marketing with Intention (Value $199)',
        },
        {
          description: 'Access to Private Community',
        },
        {
          bonus: 'TOTAL VALUE OVER',
          description: '$10,000',
        },
        {
          description: 'PAY-IN-FULL BONUS: CopyTalk Copywriting Course ($199)',
        },
      ];
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Work+Sans&display=swap');

@font-face {
  font-family: 'ivy_modelight';
  src: url('~@/assets/fonts/ivymode-light-webfont.woff2') format('woff2'),
    url('~@/assets/fonts/ivymode-light-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

#ic-signup {
  font-family: 'Work Sans', sans-serif;

  h1,
  h2,
  h3 {
    font-family: 'ivy_modelight';
  }

  a {
    color: $mustard !important;
  }

  .included {
    color: $black;
    line-height: 26px;

    h2 {
      color: $dark-gray;
    }

    .bonus {
      text-transform: uppercase;
      color: $mustard;
    }
  }

  .testimonial {
    max-width: 350px;
    padding: 2rem;

    .image {
      border-radius: 50%;
      width: 120px;
      height: 120px;
      background-size: cover;
    }

    .description {
      font-style: italic;
    }
  }
}
</style>
